<template>
	<div>
		<v-layout row wrap justify-center>
			<v-flex xs10 sm10 md10 class="mt-4">
				<v-layout row wrap justify-center>
					<v-flex
						xs2
						sm2
						md2
						v-for="(option, index) in options"
						:key="index"
						class="nav"
						style="border-bottom: 1px solid black"
					>
						<v-btn
							:key="index"
							text
							class="mx-2"
							route
							:to="option.route"
							exact
							inline-block
						>
							<span class="text-uppercase" text>{{ option.title }}</span>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 sm12 md12 v-for="(option, index) in options" :key="index">
				<component
					:is="option.component"
					v-if="option.id === $route.params.id"
					action="option.action"
				/>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
//import fb from '@/fb'
import Delete from "./Delete.vue";
import EventsPortal from "./EventPortal.vue";
import Add from "./AddForm.vue";

const baseRoute = "/EventActions";

export default {
	Components: {
		Delete,
		EventsPortal,
		Add,
	},
	props: {},
	data() {
		return {
			options: [
				{
					title: "Add",
					route: `${baseRoute}/Add`,
					component: Add,
					id: "Add",
				},
				{
					title: "Update",
					route: `${baseRoute}/Modify`,
					component: Add,
					id: "Modify",
				},
				{
					title: "Delete",
					route: `${baseRoute}/Delete`,
					component: Delete,
					id: "Delete",
				},
				{
					title: "Signup Portal",
					route: `${baseRoute}/EventsPortal`,
					component: EventsPortal,
					id: "EventsPortal",
				},
			],
		};
	},
	methods: {},
	created() {},
	updated() {},
};
</script>
